import {
    EDIT_PRICE_OVERRIDE,
    EDIT_PRICE_OVERRIDE_SUCCESS,
    EDIT_PRICE_OVERRIDE_FAILURE,
    RESET_EDIT_PRICE_OVERRIDE,
} from '../actions';

const initialState = {
    loading: false,
    success: false,
    statusCode: '',
    statusMessage: '',
};

const editPriceOverrideReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_PRICE_OVERRIDE:
            return {
                ...state,
                loading: true,
                success: false,
                statusCode: '',
                statusMessage: '',
            };
        case EDIT_PRICE_OVERRIDE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case EDIT_PRICE_OVERRIDE_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case RESET_EDIT_PRICE_OVERRIDE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default editPriceOverrideReducer;
